import React, {useState, useEffect} from "react";
import {
  Main,
  Timeline,
  Expertise,
  Project,
  Contact,
  Navigation,
  Footer,
} from "./components";
import FadeIn from './components/FadeIn';
// import Loader from './components/Loader'; 
import './index.scss';

function App() {
    const [mode, setMode] = useState<string>('dark');
    const [loading, setLoading] = useState<boolean>(true);

    const handleModeChange = () => {
        setMode(mode === 'dark' ? 'light' : 'dark');
    }

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }, []);

    // --- SYNC THEME TO BODY ---
    // This ensures popups/modals outside the root div also get the dark theme
    useEffect(() => {
        document.body.className = mode === 'dark' ? 'dark-mode' : 'light-mode';
    }, [mode]);

    // // --- LOADING TIMER ---
    // // Set to 2000ms to match the "Rolling Scope" CSS animation duration
    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         setLoading(false);
    //     }, 3500); 
        
    //     return () => clearTimeout(timer);
    // }, []);

    // // 1. Show Loader if waiting
    // if (loading) {
    //     return <Loader />;
    // }

    // 2. Show Website if done
    return (
    <div className={`main-container ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
        <Navigation parentToChild={{mode}} modeChange={handleModeChange}/>
        <FadeIn transitionDuration={700}>
            <Main/>
            <Expertise/>
            <Timeline/>
            <Project/>
            <Contact/>
        </FadeIn>
        <Footer />
    </div>
    );
}

export default App;